var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { badgeClasses } from '@mui/material/Badge';
export function badge(theme) {
    return {
        MuiBadge: {
            styleOverrides: {
                dot: {
                    borderRadius: '50%'
                },
                root: function (_a) {
                    var _b, _c, _d, _e, _f, _g;
                    var ownerState = _a.ownerState;
                    var alway = ownerState.variant === 'alway';
                    var online = ownerState.variant === 'online';
                    var busy = ownerState.variant === 'busy';
                    var offline = ownerState.variant === 'offline';
                    var invisible = ownerState.variant === 'invisible';
                    var baseStyles = (_b = {},
                        _b["&.".concat(badgeClasses.invisible)] = {
                            transform: 'unset'
                        },
                        _b.width = 10,
                        _b.zIndex = 9,
                        _b.padding = 0,
                        _b.height = 10,
                        _b.minWidth = 'auto',
                        _b['&:before, &:after'] = {
                            content: "''",
                            borderRadius: 1,
                            backgroundColor: theme.palette.common.white
                        },
                        _b);
                    return __assign(__assign(__assign(__assign(__assign({}, (online && (_c = {},
                        _c["& .".concat(badgeClasses.badge)] = __assign(__assign({}, baseStyles), { backgroundColor: theme.palette.success.main }),
                        _c))), (busy && (_d = {},
                        _d["& .".concat(badgeClasses.badge)] = __assign(__assign({}, baseStyles), { backgroundColor: theme.palette.error.main, '&:before': { width: 6, height: 2 } }),
                        _d))), (offline && (_e = {},
                        _e["& .".concat(badgeClasses.badge)] = __assign(__assign({}, baseStyles), { backgroundColor: theme.palette.text.disabled, '&:before': {
                                width: 6,
                                height: 6,
                                borderRadius: '50%'
                            } }),
                        _e))), (alway && (_f = {},
                        _f["& .".concat(badgeClasses.badge)] = __assign(__assign({}, baseStyles), { backgroundColor: theme.palette.warning.main, '&:before': {
                                width: 2,
                                height: 4,
                                transform: 'translateX(1px) translateY(-1px)'
                            }, '&:after': {
                                width: 2,
                                height: 4,
                                transform: 'translateY(1px) rotate(125deg)'
                            } }),
                        _f))), (invisible && (_g = {},
                        _g["& .".concat(badgeClasses.badge)] = {
                            display: 'none'
                        },
                        _g)));
                }
            }
        }
    };
}
